import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="otp-input"
export default class extends Controller {
  static targets = ["digit", "hidden"]

  connect() {
    this.digitTargets[0]?.focus()
  }

  handleInput(event) {
    const input = event.target
    const index = this.digitTargets.indexOf(input)
    const value = input.value

    // Clear error state on first keystroke
    this.#clearError()

    // Only allow digits
    input.value = value.replace(/\D/g, "").slice(0, 1)

    if (input.value && index < this.digitTargets.length - 1) {
      this.digitTargets[index + 1].focus()
    }

    this.updateHidden()
  }

  handleKeydown(event) {
    const input = event.target
    const index = this.digitTargets.indexOf(input)

    if (event.key === "Backspace" && !input.value && index > 0) {
      this.digitTargets[index - 1].focus()
      this.digitTargets[index - 1].value = ""
      this.updateHidden()
    }
  }

  handlePaste(event) {
    event.preventDefault()
    this.#clearError()
    const paste = (event.clipboardData || window.clipboardData).getData("text").replace(/\D/g, "").slice(0, 6)

    for (let i = 0; i < this.digitTargets.length; i++) {
      this.digitTargets[i].value = paste[i] || ""
    }

    // Focus the next empty input or the last one
    const nextEmpty = this.digitTargets.findIndex((d) => !d.value)
    if (nextEmpty >= 0) {
      this.digitTargets[nextEmpty].focus()
    } else {
      this.digitTargets[this.digitTargets.length - 1].focus()
    }

    this.updateHidden()
  }

  updateHidden() {
    const code = this.digitTargets.map((d) => d.value).join("")
    this.hiddenTarget.value = code

    if (code.length === 6) {
      this.#showSubmitting()
      const form = this.element.closest("form")
      if (form) {
        form.requestSubmit()
      } else {
        // No form (e.g. passkeys modal) — dispatch event so parent controller can handle submit
        this.element.dispatchEvent(new CustomEvent("otp:complete", { bubbles: true, detail: { code } }))
      }
    }
  }

  #clearError() {
    const form = this.element.closest("form") || this.element
    form.classList.remove("otp-error")
    const errorMsg = form.querySelector(".otp-error-msg")
    if (errorMsg) errorMsg.remove()
  }

  #showSubmitting() {
    const form = this.element.closest("form") || this.element
    form.classList.add("otp-submitting")
    this.digitTargets.forEach((d) => (d.readOnly = true))
  }
}
